import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const whatsappNumber = "1234567890"; // Replace with your WhatsApp number

const FloatingWhatsapp = () => {
  return (
    <a
      href={`https://wa.me/${+6596366354}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: "30px",
        right: "30px",
        zIndex: 1000,
        backgroundColor: "#25D366",
        borderRadius: "50%",
        width: "60px",
        height: "60px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
        color: "#fff",
        fontSize: "32px",
        textDecoration: "none",
      }}
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp />
    </a>
  );
};

export default FloatingWhatsapp;
